<template>
    <div class="lm">
        <Header ></Header>
        <!-- 使用 iframe  -->
        <iframe :src="src" width="100%" :height="height" frameborder="0"></iframe>
    </div>
  </template>
  
  <script>
  import Header from "@/components/header.vue";
  export default {
    components: {
     Header,
  },
  data() {
    return {
      src:'',
      height: window.innerHeight - 50,
    };
  },
   created() {
    this.src = process.env.VUE_APP_JUMP_URL + 'pages/modelWorker/modelHall'
  },
 
  };
  </script>
  <style scoped lang="scss">
  .lm {
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    overflow: auto;
  }
  </style>